import MissionControl from './MissionControl'

let instance: MissionControl

const getInstance = (request?: Function) => {
  if (!instance) {
    instance = new MissionControl(request)
  }

  return instance
}

export default {
  init: async config => {
    const mc = getInstance(config.request)
    await mc.init()
  },

  get: configKey => getInstance().getConfig(configKey),

  getString: (configKey): string => {
    const config = getInstance().getConfig(configKey)

    return config !== false ? config.value.toString() : ''
  },

  isFeatureEnabled: configKey => getInstance().isFeatureEnabled(configKey),

  isReadyForQueries: () => getInstance().isReadyForQueries(),
}
